// dropdowns

import clickOutside from '../helpers/click-outside';

var triggerFooter = document.querySelectorAll(".footer-menu--header");
var triggerDropdown = document.querySelectorAll(".dropdown");
var triggerDrop = document.querySelector(".dropdown");
var sideMenu = document.querySelector(".sidemenu");

document.addEventListener('click', (e) => {
    if (e.target.closest('.dropdown') === null && e.target !== triggerDropdown) {
        var dropdownOpen = document.querySelector('.dropdown.open');
        if (dropdownOpen) {
            document.querySelector('.dropdown.open').classList.remove("open");
        }
    }
});

var i;

for (i = 0; i < triggerDropdown.length; i++) {
    triggerDropdown[i].addEventListener("click", function () {
        this.classList.toggle("open");
    });
}

for (i = 0; i < triggerFooter.length; i++) {
    var curText = triggerFooter[i].innerText;
    triggerFooter[i].addEventListener("click", function () {
        var parent = this.parentElement;
        parent.classList.toggle("open");
    });
}

// for (i = 0; i < sideMenu.length; i++) {
//     filterToggle[i].addEventListener("click", function () {
//       this.classList.toggle("active");
//       var panel = this.nextElementSibling;
//       if (panel.style.maxHeight) {
//         panel.style.maxHeight = null;
//       } else {
//         panel.style.maxHeight = panel.scrollHeight + "px";
//       }
//     });
// }



// WEBPACK FOOTER //
// ./scripts/components/dropdown.js